import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UserService, BaseComponent, Video, Lesson, ContentService, environment, HelperService } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";
import { ClipboardService } from "ngx-clipboard";

@Component({
  selector: "fui-video-rail",
  templateUrl: "video-rail.component.html",
  standalone: false,
})
export class VideoRailComponent extends BaseComponent {
  @Input() videos: Array<Video>;
  @Input() lesson: Lesson;
  @Input() title: string;
  @Input() description: string;
  @Input() image: string;
  @Input() leftMargin: boolean = true;
  @Output() showMoreVideos: EventEmitter<void> = new EventEmitter();
  public togglingAddLessonToLibrary: boolean = false;
  public copied: boolean = false;
  constructor(
    userService: UserService,
    public contentService: ContentService,
    public appService: AppService,
    public helperService: HelperService,
    private _clipboardService: ClipboardService
  ) {
    super(userService);
  }

  toggleSaveLesson(lesson) {
    this.togglingAddLessonToLibrary = true;
    let existingData = this.contentService.userLearnData[lesson.type == "lesson" ? "lessons" : "courses"][lesson.id];
    let saved = existingData?.enrolled ? false : true;
    let args: any = {
      user_id: this.user.id,
      learn_group_id: lesson.id,
      enrolled: saved,
    };
    if (!existingData?.date_started) args.date_started = new Date();

    this.contentService.saveUserLearnGroupData(lesson.id, args).subscribe({
      next: (result) => {
        this.togglingAddLessonToLibrary = false;
      },
      error: (error) => {
        this.appService.alertError(error);
        this.togglingAddLessonToLibrary = false;
      },
    });
  }

  copyLink(lesson) {
    this.copied = true;
    this._clipboardService.copy(environment.mypresonusUrl + "learn/" + lesson.type + "/" + lesson.id);
    event.stopPropagation();
    setTimeout(() => {
      this.copied = false;
    }, 1000);
  }
}
